import Storage from '@/amplify/storage';
import localStorageUtil from '@/common/utils/localStorageUtil';

/**
 * Handle upload file to tmp folder
 * save file to tmp folder
 * @param {*} API
 * @param {*} file
 */
export const uploadFileToS3InTMPFolder = async file => {
    const timeStamp = new Date().getTime();
    const newFileName = `${file.name}`;
    const affiliationOrganization = localStorageUtil.getAffiliationOrganization();
    const keyFile = `tmp/${affiliationOrganization}/${timeStamp}/${newFileName}`;
    const result = await Storage.put(keyFile, file, {
        contentType: file.type,
        level: 'public',
        contentDisposition: `inline; filename=${encodeURIComponent(newFileName)}`
    });
    return result;
};

export const uploadFileToS3InPath = async (file, path) => {
    const newFileName = `${file.name}`;
    const keyFile = `${path}/${newFileName}`;
    const result = await Storage.put(keyFile, file, {
        contentType: file.type,
        level: 'public',
        contentDisposition: `inline; filename=${encodeURIComponent(newFileName)}`
    });
    return result;
};
